// Profile.styles.ts
import { Box, Container, Paper } from "@mui/material";
import { styled } from "@mui/system";

export const StyledContainer = styled(Container)(({ theme }) => ({
  maxWidth: "600px",
  marginTop: theme.spacing(4),
  paddingBottom: theme.spacing(6),
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: theme.spacing(4),
}));

export const InfoBlock = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}));

export const InfoCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.spacing(1.5),
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

export const PasswordCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(1.5),
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.grey[50],
}));

export const FormContainer = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  marginTop: theme.spacing(1),
}));
